wbApp.controller('BankPairedInvoiceCtrl', ['$scope', '$window', 'invoiceSvc',
function ($scope, $window, invoiceSvc) {

    $scope.selectedInvoiceID = null;
    $scope.model = null;

    $scope.$on('selectedAccountingBookTransactionChanged', function (e, data) {
        if (!data) {
            $scope.model = null;
            $scope.selectedInvoiceNo = null;
        } else if ($scope.selectedInvoiceID !== data.invoiceID) {
            $scope.selectedInvoiceID = data.invoiceID;
            if (!!$scope.selectedInvoiceID) {
                $scope.model = invoiceSvc.getInvoiceEvidenceByInvoiceID($scope.selectedInvoiceID);
            } else {
                $scope.model = null;
            }
        }
    });


    $scope.onPrintInvoice = function (invoiceID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + invoiceID + '&ReportIDType=1',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }
}]);
